import React from "react";
import "./Vision_Mission.css";

const VisionMission = () => {
  return (
    <section className="vision-mission-section">
      <div className="container">
        <div className="row align-items-center text-center vision-row">
          <div className="col-lg-6 col-md-6 vision-box">
            <h2>
              Our <span>Vision</span>
            </h2>

            <p>
              To make travel simple, transparent, and enjoyable by providing
              well-planned tours, honest pricing, and reliable support at every
              step of the journey.
            </p>
          </div>

          <div className="col-lg-6 col-md-6 mission-box">
            <h2>
              Our <span>Mission</span>
            </h2>

            <p>
              To become a trusted travel partner known for reliability,
              personalized service, & unforgettable travel experiences helping
              people explore the world with confidence, comfort.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
